// extracted by mini-css-extract-plugin
export var blue = "projects-module--blue--dnzm-";
export var btn = "projects-module--btn--XuCvH";
export var card = "projects-module--card--KjXdY";
export var cards = "projects-module--cards--ZMqVZ";
export var contentContainer = "projects-module--contentContainer--JAIpt";
export var green = "projects-module--green--zhjwV";
export var header = "projects-module--header--XQ2yk";
export var imageContainer = "projects-module--imageContainer--eI9tg";
export var orange = "projects-module--orange--Himlt";
export var red = "projects-module--red--peAha";